<template>
  <basic-card>
    <template slot="header">
      Process statuses for query {{ fullQueryName }}
    </template>
    <toolbox>
      <toolbox-button @press="refreshProcesses" :help-text="$t('refreshProcesses')">
        <icon :icon="['fal', 'sync']"/>
      </toolbox-button>
    </toolbox>
    <data-table
        :configuration="importProcessTableConfig"
        :data="selectedImportProcesses"
        :component-id="`processes-widget-${displayName}`"
    />
  </basic-card>
</template>

<script>
import BasicCard from "@/components/layout/BasicCard";
import DataTable from "@/components/table/DataTable";
import {mapGetters} from "vuex";
import Toolbox from "@/components/toolbox/Toolbox";
import ToolboxButton from "@/components/toolbox/ToolboxButton";

export default {
  name: "SimpleProcessHistoryWidget",
  components: {ToolboxButton, Toolbox, DataTable, BasicCard},
  props: {
    displayName: String,
    processHistoryQuery: String
  },
  data: function () {
    return {
      fullQuery: {name: "N/A"},
      importProcessTableConfig: {
        allowEdit: true,
        columns: [
          {
            caption: "Id",
            datum: d => d.id.substr(d.id.length - 5)
          },
          {
            caption: "Progress",
            datum: d => this.$formats.formatNumber(Math.round((d?.progress ?? 0) * 100), "0") + "%",
            style: d => ({
              background: 'linear-gradient(90deg, #C84A4B ' + this.$formats.formatNumber(Math.round((d?.progress ?? 0) * 100), "0") + "%" + ', #00000000 ' + this.$formats.formatNumber(Math.round((d?.progress ?? 0) * 100), "0") + "%" + ')',
              color: 'white'
            })
          },
          {
            caption: "Job definition",
            datum: d => this.importDefinition(d.definitionId) == null ? "N/A" : this.importDefinition(d.definitionId).displayName
          },
          {
            caption: "Started by",
            datum: d => this.user(d.startedBy)?.username ?? `User[${d.startedBy}]`
          },
          // {
          //     caption: "Source",
          //     datum: d => d.values.source == undefined ? 'N/A' : d.values.source
          // },
          // {
          //     caption: "File",
          //     datum: d => d.values.file
          // },
          {
            caption: "Last message",
            datum: d => d.lastMessage
          },
          {
            caption: "Start timestamp",
            datum: d => this.$formats.formatDateTime(new Date(d.startTime))
          },
          {
            caption: "Finish timestamp",
            datum: d => d.finishTime != null ? this.$formats.formatDateTime(new Date(d.finishTime)) : "-"
          }
        ]
      }
    }
  },
  computed: {
    selectedImportProcesses() {
      return [... this.$store.getters[`importProcesses/importProcesses`]].sort((a, b) => {
        return this.$moment(b.startTime).diff(this.$moment(a.startTime), 'minutes')
      })
    },
    ...mapGetters({
      importDefinition: 'importDefinitions/importDefinition',
      user: 'users/user'
    }),
    fullQueryName() {
      return this.fullQuery?.name ?? "N/A";
    }
  },
  methods: {
    async refreshProcesses() {
      await this.$store.dispatch(`importProcesses/refreshImportProcessesPaged`, {
        page: 0,
        size: 500,
        query: this.fullQuery
      })
    }
  },
  async mounted() {
    await this.$store.dispatch("processQueries/refreshProcessQueries");
    this.fullQuery = this.$store.getters[`processQueries/queryById`](this.processHistoryQuery);
    await this.refreshProcesses();
  }
}
</script>

<style scoped>

</style>